var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SuspenseCache_instances, _SuspenseCache_cache, _SuspenseCache_getCachedOrRejected;
function promiseWithResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((resolve0, reject0) => {
        resolve = (data) => {
            result.resolution = { status: "resolved", data };
            resolve0(data);
        };
        reject = (data) => {
            result.resolution = { status: "rejected", data };
            reject0(data);
        };
    });
    /**
     * Necessary to prevent some runtime environments from throwing unhandled promise rejections.
     */
    promise.catch(console.error);
    const result = {
        promise,
        resolve,
        reject,
        resolution: { status: "pending", data: promise },
    };
    return result;
}
export class SuspenseCache {
    constructor() {
        _SuspenseCache_instances.add(this);
        _SuspenseCache_cache.set(this, new Map());
    }
    init(key) {
        if (!__classPrivateFieldGet(this, _SuspenseCache_cache, "f").has(key)) {
            __classPrivateFieldGet(this, _SuspenseCache_cache, "f").set(key, promiseWithResolvers());
        }
    }
    get(key) {
        return __classPrivateFieldGet(this, _SuspenseCache_instances, "m", _SuspenseCache_getCachedOrRejected).call(this, key).promise;
    }
    use(key, fn) {
        if (!__classPrivateFieldGet(this, _SuspenseCache_cache, "f").has(key) && fn) {
            this.init(key);
            fn()
                .then((data) => this.resolve(key, data))
                .catch((reason) => {
                const error = reason instanceof Error ? reason : new Error(String(reason));
                this.reject(key, error);
            });
        }
        const cached = __classPrivateFieldGet(this, _SuspenseCache_instances, "m", _SuspenseCache_getCachedOrRejected).call(this, key);
        if (cached.resolution.status !== "resolved") {
            throw cached.resolution.data;
        }
        return cached.resolution.data;
    }
    resolve(key, data) {
        if (!__classPrivateFieldGet(this, _SuspenseCache_cache, "f").has(key)) {
            __classPrivateFieldGet(this, _SuspenseCache_cache, "f").set(key, promiseWithResolvers());
        }
        __classPrivateFieldGet(this, _SuspenseCache_cache, "f").get(key).resolve(data);
    }
    reject(key, reason) {
        if (!__classPrivateFieldGet(this, _SuspenseCache_cache, "f").has(key)) {
            __classPrivateFieldGet(this, _SuspenseCache_cache, "f").set(key, promiseWithResolvers());
        }
        __classPrivateFieldGet(this, _SuspenseCache_cache, "f").get(key).reject(reason);
    }
    reset() {
        __classPrivateFieldGet(this, _SuspenseCache_cache, "f").clear();
    }
    entries() {
        return __classPrivateFieldGet(this, _SuspenseCache_cache, "f").entries();
    }
}
_SuspenseCache_cache = new WeakMap(), _SuspenseCache_instances = new WeakSet(), _SuspenseCache_getCachedOrRejected = function _SuspenseCache_getCachedOrRejected(key) {
    const cached = __classPrivateFieldGet(this, _SuspenseCache_cache, "f").get(key);
    if (!cached) {
        const entry = promiseWithResolvers();
        entry.reject(new Error(`Key "${String(key)}" not found`));
        return entry;
    }
    return cached;
};
